import { Injectable } from '@angular/core';

/**
 * Servicio para manejo de alerts
 */
@Injectable()
export class AlertService {

  /**
   * Titulo de la alerta
   */
  title: string;
 /**
  * Cuerpo de la alerta
  */
  body: string;
  /**
   * etiqueta en boton aceptar
   */
  buttonAccept: string;
  /**
   * etiqueta en boton cancelar
   */
  buttonCancel: string;
  /**
   * Imagen u otro componente a mostrar
   */
  item: any;

  /**
   * Inicializa constructor
   */
  constructor(){}


  /**
   * Setea los valores que se mostraan en la alerta
   * @param mTitle 
   * @param mBody 
   * @param mButtonAccept 
   * @param mButtonCancel 
   * @param mItem 
   */
  setMessageData(mTitle: string, mBody: string, mButtonAccept: string, mButtonCancel: string, mItem?: any): AlertService{
      this.title = mTitle !== "" ? mTitle : "";
      this.body = mBody !== "" ? mBody : "Por el momento el servicio no está disponible, por favor intente de nuevo más tarde.";
      this.buttonAccept = mButtonAccept !== "" ? mButtonAccept : "Aceptar";
      this.buttonCancel = mButtonCancel !== "" ? mButtonCancel : "";
      this.item = mItem;
      return this;
  }

}
